import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchCatalogs, deleteCatalog, clearCatalogsErrors } from '../../actions';
import DialogModal from '../home/DialogModal';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  catalogsList: PropTypes.object.isRequired,
  catalogDelete: PropTypes.bool,
  delete: PropTypes.bool,
  onCatalogDisable: PropTypes.func,
};


class ShowCatalogs extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      deleteId: 0,
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.catalogDelete && (this.state.delete || nextProps.catalogsList.delete)) {
      const catalogsList = nextProps.catalogsList;
      catalogsList.delete = false;
      this.setState({
        alertOpen: true,
        alertMessage: 'Catalog deleted!',
        delete: false,
        catalogsList,
      });
      this.handleClose();
    }

    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: 0,
    });
  }
  handleDelete() {
    this.setState({
      delete: true,
    });
    this.props.dispatch(deleteCatalog(this.state.deleteId));
    this.props.dispatch(fetchCatalogs({ page: 1 }));
  }
  handleDisable(item) {
    const data = item;
    data.disabled = !item.disabled;
    this.props.onCatalogDisable(data);
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearCatalogsErrors());
    this.props.dispatch(fetchCatalogs({ page: 1 }));
  }
  renderRowsTable() {
    return this.props.catalogsList.results.map(item =>
      <TableRow key={item.id}>
        <TableRowColumn key={item.id}>{item.name}</TableRowColumn>
        <TableRowColumn key={item.id}>{item.description}</TableRowColumn>
        <TableRowColumn key={item.id}>
          <ActionButtons
            onEdit={`/catalogs/${item.id}`}
            onView={`/catalogs/view/${item.id}`}
            onDelete={() => this.handleOpen(item.id)}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Catalog"
          dialogMessage="Do you really want to delete this catalog?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn>Description</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowCatalogs.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowCatalogs.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    catalogDelete: state.catalogs.catalogDelete,
    delete: state.delete,
    error: state.catalogs.error,
  };
}

export default connect(mapStateToProps)(ShowCatalogs);



// WEBPACK FOOTER //
// ./src/components/catalogs/ShowCatalogs.js